import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useDetailConfigOverrider, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'campaigns/campaignoperation';
const model = 'campaigns/campaignOperation';
const modelExposedName = 'CampaignOperation';
const wizardAction = 'create';

const Create = (params) => {

    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);
    const { overrideDetailFields } = useDetailConfigOverrider();
    // DATA PROVIDER
    const { doAction, item, loadOne, loadAll, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    console.info('createRPO', existingModules)
    const modelName = existingModules.modelName
    const detailConfig = (params.detailConfigOverride) ? overrideDetailFields(existingModules[dataProviderName].detailConfig, params.detailConfigOverride) : existingModules[dataProviderName].detailConfig;
    useEffect(() => {
        loadOne(params.filters?._id);
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])


    
    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    return <>
        <DetailComponent
            values={{
                propertyID:'W-',
                status:'new',
                product:'buy',
                name:'',
                email:'',
                registered_at: new Date().toISOString(),
                assigned_at: new Date().toISOString(),
                legalEntity:discover('legalEntity'),
                employment:discover('employment'),
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t('New {{itemname}}', {itemname:t(modelExposedName)})}
            canSave={userCapabilities && userCapabilities[dataProviderName+'.create']}
            header={
                <InfoHeader
                    view="wizard"
                    title={t('Create new {{itemname}}', {itemname:t(modelExposedName)})}
                    subtitle={t('Fill the basic information to create a new {{itemname}} that you will be able to edit via the standard interface', {itemname:t(modelExposedName)})}
                />
            }
            {...params}
        />
    </>
}

export default Create;


